<template>
  <main class="main-2026">
    <template v-if="currentPage !== null">
      <Transition name="fade" :duration="20" mode="out-in">
        <CheckAge v-if="currentPage === ''" @adult-check="handleAdultCheck" />
        <AdDream v-else-if="currentPage === 'dream'" />
        <NotFound v-else />
      </Transition>
    </template>
  </main>
</template>

<script setup>
import CheckAge from '../common/CheckAge.vue'
import NotFound from '../common/NotFound.vue'
import AdDream from './AdDream.vue'
import { useHashRouter } from '../common/useHashRouter.js'

const { currentPage, updatePage, handleAdultCheck } = useHashRouter({
  validHashes: ['', 'dream'],
  onAuthenticated: () => updatePage('dream')
})
</script>

<style scoped>
.main-2026 {
  background-color: #000000;
  display: flex;
  font-family: 'NanumSquare', sans-serif;
  color: #ffffff;
  align-items: center;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100svh;
  width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.02s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
